<div class="recherche-container">
    <i class="material-icons-outlined icone-left">search</i>
    <input autofocus type="text" [placeholder]="'admin.recherche.placeholder' | translate" (keyup)="onKeyup($event)"/>
</div>
<list-view [liste]="liste" *ngIf="isResponded && liste" class="recherche-listview"></list-view>
